export default {
  failed_to_open: 'No se pudo abrir la incorporación para este restaurante. Por favor, inténtalo de nuevo.',
};
